import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-checked", "checked"]
const _hoisted_2 = {
  class: "flex start-xs",
  role: "button"
}
const _hoisted_3 = { class: "b-custom-checkbox__input flex middle-xs center-xs" }
const _hoisted_4 = { class: "b-custom-checkbox__text black regular fs-bigger" }

import { computed, type WritableComputedRef } from 'vue';
import CheckIcon from '@/views/icons/CheckIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCheckboxComponent',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  requiredError: {
    type: Boolean,
    required: false,
  },
  id: String,
},
  emits: ['update:modelValue', 'onChange'],
  setup(__props, { emit }) {

const props = __props





const value: WritableComputedRef<boolean> = computed({
  get() {
    return props.modelValue;
  },
  set(_value) {
    emit('update:modelValue', _value);
    emit('onChange');
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["b-custom-checkbox", { 'required-highlighted': __props.requiredError }]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (value.value = !_unref(value)))
  }, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: __props.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        "aria-checked": _unref(value),
        checked: _unref(value)
      }, null, 8, _hoisted_1), [
        [_vModelCheckbox, _unref(value)]
      ]),
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          (_unref(value))
            ? (_openBlock(), _createBlock(CheckIcon, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ], 2))
}
}

})